<div class="dashboard">
  <nav class="nav">
    <div class="container-fluid d-flex justify-content-between">
      <!-- <button class="btn btn-primary btn-lg" >{{ 'BUTTON_LOGIN' | translate}}</button> -->
      <app-navbar></app-navbar>

      <button (click)="openInfoPage()" class="btn btn-primary btn-lg">
        <div>Hoe werkt Groeimeter?</div>
      </button>
    </div>
  </nav>
  <div class="container">
    <div class="row d-flex justify-content-center">
      <img class="logo" src="assets/GroeimeterLogo_2025.gif" />
    </div>
    <div class="row">
      <div class="routes">
        <a href="javascript:void(0)" (click)="setAppModule(0)">
          <img
            class="route-tile rekenen"
            src="assets/tiles/Rekenen.jpg"
            alt=""
          />
        </a>
        <a href="javascript:void(0)" (click)="setAppModule(1)">
          <img
            class="route-tile spelling"
            src="assets/tiles/Spelling.jpg"
            alt=""
          />
        </a>
      </div>
    </div>
  </div>
  <footer class="footer mt-auto">
    <div class="container-fluid">
      <div class="footer-wrapper d-flex justify-content-end w-100">
        <img class="footer-logo" src="/assets/Cito_logo.svg" alt="" />
      </div>
    </div>
  </footer>
</div>
